import { Auth } from "aws-amplify";
// eslint-disable-next-line import/no-extraneous-dependencies
import { CognitoUser } from "amazon-cognito-identity-js";
import { useCallback, useRef } from "react";

import { UseAuthReturnType } from "./types";

export const useAuth = (): UseAuthReturnType => {
  const userRef = useRef<CognitoUser>();
  const signIn = useCallback(
    async (phoneNumber: string): Promise<CognitoUser> => {
      await Auth.signOut({ global: true });

      userRef.current = (await Auth.signIn(phoneNumber)) as CognitoUser;

      return userRef.current;
    },
    []
  );
  const answerChallenge = useCallback(
    async (answer: string): Promise<CognitoUser> => {
      if (!userRef.current) {
        throw new Error(
          "First you have to call 'signIn' method to get user handle."
        );
      }

      await Auth.sendCustomChallengeAnswer(userRef.current, answer);

      userRef.current = (await Auth.currentUserPoolUser()) as CognitoUser;

      return userRef.current;
    },
    []
  );
  const signOut = useCallback(async () => {
    await Auth.signOut();
  }, []);

  return { signIn, answerChallenge, signOut };
};
